<template>
    <div class="text-input">
        <div @click="closeList()" v-if="open" class="dropdown-background"></div>
        <label><b>{{label}}</b></label>
        <div class="input-group">

            <!-- <select class="form-control"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @change="updateColleague"
                    :disabled="disabled"
                    :aria-label="{label}">
                <option :value="null" >None</option>
                <option v-for="(pm, index) in colleagues"
                        :key="pm.Code"
                        :value="pm.Code">{{ pm.FirstName }} {{ pm.LastName }} - {{pm.Email}}</option>
            </select>
            <i class="fa fa-chevron-down"></i> -->
            <input class="form-control pr-4"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @focus="openList()"
                    ref="colleagueSelect"
                    :disabled="disabled"
                    @blur="textInput"
                    :aria-label="{label}"/>
                 <i @click="focusAutoComplete()" class="fa fa-angle-down icon-dropdown"  aria-hidden="true"></i>
            
            <div v-if="open" class="rep-list-card card ">
                <ul class="p-0 m-0">
                    <div class="pointer rep-list" @click="updateValue(null)">None</div>
                    <div class="pointer rep-list" v-for="(pm, index) in colleagueOptions" :key="pm.Code + '-' + index" @click="updateValue(pm)">{{ pm.FirstName }} {{ pm.LastName }} - {{pm.Email}}</div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ColleagueSelect",
        props: {
            colleagues: {
                type: Array,
            },
            colleagueSelectType: {
                type: String,
            },
            allColleagues: {
                type: Array,
            },
            label: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            value: {
            },
            name: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            isCombobox: {
                type: Boolean,
                default: false,
            }
        },

        data(){
            return {
                displayValue: "",
                open: false
            }
        },
        methods: {
            focusAutoComplete(){
                this.$refs.colleagueSelect.focus()
            },
            // updateColleague($event){
            //     let value = $event.target.value;
            //     let colleagueCode = value ? Number(value) : null;
            //     this.$emit('input',colleagueCode);
            // },
            openList(){
                // Only clear displayValue for combobox mode when user wants to type
                // For regular dropdown mode, preserve the current display value
                if (this.isCombobox) {
                    // Keep current displayValue for combobox
                } else {
                    // For regular dropdown, preserve current selection display
                    this.displayValue = this.getColleagueDescription(this.value);
                }
                this.open = true;
            },
            closeList(){
                this.displayValue = this.isCombobox ? this.displayValue : this.getColleagueDescription(this.value)
                this.open = false;
            },
            textInput(){
                // this.$emit('updateName', this.displayValue, this.colleagueSelectType)
                // this.$emit('input', null);
                // console.log('textInput', this.displayValue)
                if(!this.isCombobox) return;
                setTimeout(() => {
                    this.updateValue(null)
                }, 100);
                
            },
            updateValue(Colleague){
                if(!Colleague){
                    if(this.isCombobox) this.$emit('updateName', this.displayValue, this.colleagueSelectType);
                    this.$emit('input', null);
                    this.closeList();
                    return;
                }

                // Use consistent format with getColleagueDescription
                this.displayValue = Colleague.FirstName + " " + Colleague.LastName + " - " + Colleague.Email;
                let colleagueCode = Colleague.Code;
                this.$emit('input',colleagueCode);
                this.closeList()
            },
            getColleagueDescription(code){
                if(code === null) return this.isCombobox ? this.displayValue : "";

                // Helper function to find colleague by code or id
                const findColleague = (colleagues, searchValue) => {
                    // First try to find by Code
                    let index = colleagues.map(rep => rep.Code).indexOf(searchValue);
                    if(index >= 0) {
                        return colleagues[index];
                    }
                    // If not found by Code, try by Id
                    index = colleagues.map(rep => rep.Id).indexOf(searchValue);
                    if(index >= 0) {
                        return colleagues[index];
                    }
                    return null;
                };

                // First try to find in allColleagues array
                let colleague = findColleague(this.allColleagues, code);
                if(colleague) {
                    return colleague.FirstName + " " + colleague.LastName + " - " + colleague.Email;
                }

                // If not found in allColleagues, try the filtered colleagues array as fallback
                colleague = findColleague(this.colleagues, code);
                if(colleague) {
                    return colleague.FirstName + " " + colleague.LastName + " - " + colleague.Email;
                }

                // If still not found, return empty string (but preserve combobox value if applicable)
                return this.isCombobox ? this.displayValue : ""
            }
            
        },
        watch: {
            value: function(){
                this.displayValue = this.getColleagueDescription(this.value);
            },
            colleagues: function(){
                this.displayValue = this.getColleagueDescription(this.value);
            }
        },
        computed: {
            colleagueOptions(){
                let repOptions = this.colleagues.filter(rep => {
                    if(!rep.IsDeleted) {
                        // Only filter when dropdown is open and user is actively typing
                        // If displayValue is empty or matches the current selection, show all options
                        if (!this.open || !this.displayValue || this.displayValue.trim() === "") {
                            return true;
                        }

                        // Check if displayValue matches the current selection (to avoid filtering out selected item)
                        let currentSelectionDescription = this.getColleagueDescription(this.value);
                        if (this.displayValue === currentSelectionDescription) {
                            return true;
                        }

                        // Filter based on user input for autocomplete functionality
                        let description = rep.FirstName + " " + rep.LastName + " - " + rep.Email;
                        description = description.toLowerCase();
                        let searchTerm = this.displayValue.toLowerCase();
                        return description.includes(searchTerm);
                    }
                    return false;
                })

                return repOptions.sort(function(a, b) {
                    var textA = a.FirstName.toUpperCase();
                    var textB = b.FirstName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            }

        },
        created(){
            this.displayValue = this.isCombobox ? this.name : "";
            //console.log('colleague select create', this.displayValue, this.isCombobox, this.name, this.value)
            this.displayValue = this.getColleagueDescription(this.value);
        }
    }
</script>

<style scoped lang="scss">
    .icon-dropdown{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .rep-list-card{
        z-index: 15;
        margin-top: 40px;
        position: absolute;
        max-height: 300px;
        overflow: scroll;
        
    }
    .rep-list{
        border-bottom: solid .5px grey;
        z-index: 20;
        padding: 5px;
        &:hover {
            background-color: $ss-blue-light;
            color: black;
        }
    }
    .dropdown-background{
        position: fixed;
        min-width: 100%;
        min-height: 100%;
        z-index: 10;
        left: 0; 
        top: 0;
        }
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background: inherit;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            padding-right: 5px;
        }
    }
</style>